// extracted by mini-css-extract-plugin
export default {"content":"InvestmentStrategy_content__kJgIa","title":"InvestmentStrategy_title__w873X","strong":"InvestmentStrategy_strong__sBI9n"};